import { render, staticRenderFns } from "./religionIndex.vue?vue&type=template&id=1f639baa&scoped=true&"
import script from "./religionIndex.vue?vue&type=script&lang=js&"
export * from "./religionIndex.vue?vue&type=script&lang=js&"
import style0 from "./religionIndex.vue?vue&type=style&index=0&id=1f639baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f639baa",
  null
  
)

export default component.exports